// Note: The first file of a module here, must also register the module

import "./issue-list.component";
import "./issues.component";

import "./modals";
